import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/BuildingInsurance/keyPointVerticalNumericData.json';

import SeoSnakeGuideComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideComponent';
import SeoSnakeGuideMobileComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideMobileComponent';
import snakeGuideData from '../../json/components/HomePages/BuildingInsurance/snakeGuideData.json';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/BuildingInsurance/partnerBrandsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/BuildingInsurance/fourBlogCardsData.json';

import ThreeColumnCardComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardComponent';
import ThreeColumnCardMobileComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardMobileComponent';
import threeColumnCardData from '../../json/components/HomePages/BuildingInsurance/threeColumnCardData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/BuildingInsurance/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/BuildingInsurance/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsDataAll from '../../json/components/HomePages/BuildingInsurance/scrollingCardsAllData.json';
import scrollingCardsData2 from '../../json/components/HomePages/BuildingInsurance/scrollingCardsData2.json';
import scrollingCardsData3 from '../../json/components/HomePages/BuildingInsurance/scrollingCardsData3.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsMobileComponent';
import sectionStepsData from '../../json/components/HomePages/BuildingInsurance/sectionStepsData.json';

import ExpertQuotesComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesComponent';
import ExpertQuotesMobileComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesMobileComponent';
import expertQuotesData from '../../json/components/HomePages/BuildingInsurance/expertQuotesData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function BuildingInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/buildings-insurance-quote/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestBuildingInsuranceQuotes_CrossSell"
        fallbackKey="latestBuildingInsuranceQuotes"
        navigateTo="/buildings-insurance-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'A home is an investment. Protect it properly.'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'A home is an investment. Protect it properly.'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoSnakeGuideComponent data={snakeGuideData} />
        ) : (
          <SeoSnakeGuideMobileComponent data={snakeGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ThreeColumnCardComponent data={threeColumnCardData} />
        ) : (
          <ThreeColumnCardMobileComponent data={threeColumnCardData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ExpertQuotesComponent expertData={expertQuotesData} />
        ) : (
          <ExpertQuotesMobileComponent expertData={expertQuotesData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsComponent data={sectionStepsData} />
        ) : (
          <SectionStepsMobileComponent data={sectionStepsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData2} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData2} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Home sweet (protected) home.'}
            color={'blue'}
            buttonText={'Hippo it'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Home sweet (protected) home.'}
            color={'blue'}
            buttonText={'Hippo it'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData3} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData3} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="buildings-insurance"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="buildings-insurance"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataAll} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataAll} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default BuildingInsurancePage;
